import _ from 'lodash'

export default {

  computed: {
    errors() {
      /* eslint-disable no-unused-vars, no-unused-expressions */
      const errors = []

      const price = _.get(this.cashSaleVehicle, 'carmodel.car.net_list_price')
      const powerKW = _.get(this.cashSaleVehicle, 'item_powerkw')
      const consumptionCombined = parseInt(_.get(this.cashSaleVehicle, 'carmodel.car.consumption'))
      const consumptionHighway = _.get(this.cashSaleVehicle, 'carmodel.car.consumption_outoftown')
      const consumptionUrban = _.get(this.cashSaleVehicle, 'carmodel.car.consumption_town')
      const consumptionPowerCombined = _.get(this.cashSaleVehicle, 'item_mobilede_data.consumptionPowerCombined')

      const co2 = _.get(this.cashSaleVehicle, 'carmodel.car.co2')
      const co2Label = _.get(this.cashSaleVehicle, 'carmodel.car.co2label')

      const manufacturer = _.get(this.cashSaleVehicle, 'carmodel.car.mobile_make')
      const model = _.get(this.cashSaleVehicle, 'carmodel.car.mobile_model')
      const sharedTitle = _.get(this.cashSaleVehicle, 'carmodel.car.shared_title')

      const type = _.get(this.cashSaleVehicle, 'carmodel.car.type')
      const weight = _.get(this.cashSaleVehicle, 'carmodel.car.weight')
      const mobileDeData = _.get(this.cashSaleVehicle, 'item_mobilede_data')
      const fuel = _.get(this.cashSaleVehicle, 'item_mobilede_data.fuel')
      const isHybridPlugin = (_.get(this.cashSaleVehicle, 'item_mobilede_data.feature.hybridPlugin') === 'true')

      console.log(['isHybridPlugin', isHybridPlugin])

      !this.isNumberOrDecimal(price) ? errors.push('UPE') : null
      !this.isNumberOrDecimal(powerKW) ? errors.push('Leistungsangabe in KW') : null

      if (fuel === 'ELECTRICITY') {
        !this.isNumberOrDecimal(consumptionPowerCombined, false) ? errors.push('Verbrauch kWh (kombiniert)') : null
      } else if (fuel === 'HYBRID') {
        !this.isNumberOrDecimal(consumptionCombined, false) ? errors.push('Verbrauch (Kombiniert)') : null

        if (isHybridPlugin) {
          !this.isNumberOrDecimal(consumptionPowerCombined, false) ? errors.push('Verbrauch kWh (kombiniert)') : null
        } else {
          !this.isNumberOrDecimal(co2, false) ? errors.push('Co2 Ausstoß ') : null
        }
      } else {
        !this.isNumberOrDecimal(consumptionCombined, false) ? errors.push('Verbrauch (Kombiniert)') : null
        !this.isNumberOrDecimal(consumptionHighway, false) ? errors.push('Verbrauch (Außerorts)') : null
        !this.isNumberOrDecimal(consumptionUrban, false) ? errors.push('Verbrauch (Innerorts)') : null
        !this.isNumberOrDecimal(co2, false) ? errors.push('Co2 Ausstoß ') : null
      }

      !this.isNumberOrDecimal(weight) ? errors.push('Gewicht') : null

      _.isEmpty(co2Label) ? errors.push('Co2 Angabe oder Gewicht') : null
      _.isEmpty(manufacturer) ? errors.push('Hersteller') : null
      _.isEmpty(model) ? errors.push('Model') : null
      _.isEmpty(sharedTitle) ? errors.push('Fahrzeugtitel') : null
      _.isEmpty(type) ? errors.push('Kategorie (Neuwagen, TZL, etc.)') : null
      _.isEmpty(fuel) ? errors.push('Treibstoffangabe') : null

      return errors
      /* eslint-enable no-unused-vars, no-unused-expressions */
    }
  },

  methods: {
    isNumberOrDecimal(value, checkNull = true) {
      // eslint-disable-next-line no-param-reassign
      value = parseFloat(value)

      if (_.isNaN(value)) {
        return false
      }

      if (checkNull && value <= 0) {
        return false
      }

      return true
    }
  }

}
